import { ROLE_DICT } from '../../constants';
import SelectableSearchableSortableListCtrl from '../manage/SelectableSearchableSortableListCtrl';
import { EMPLOYEE_HEADER_HEIGHT, ACTION_BAR_HEIGHT } from '../constants';

import templateUrl from './groupEmployeeTab.html';
import addEmployeeModalUrl from './addEmployeeModal.html';

class GroupEmployeeTabCtrl extends SelectableSearchableSortableListCtrl {
  constructor(
    Authentication,
    PersonaCollection,
    UserUtils,
    ConfirmService,
    filterFilter,
    $parse,
    $scope,
    $rootScope,
    $uibModal
  ) {
    'ngInject';

    super(filterFilter, $parse, 'searchValue', (invalidateFn) => {
      $scope.$on('$destroy', PersonaCollection.onChange(invalidateFn));
    });

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      UserUtils,
      ConfirmService,
      $rootScope,
      $uibModal,
    });
  }

  $onInit() {
    this.roleDict = ROLE_DICT;
    this.sortMethod = 'normalizedDisplayName';
    this.manageMode = this.Authentication.user.isManager;
    this.employeeHeaderHeight = EMPLOYEE_HEADER_HEIGHT;
  }

  get stickyBarOffset() {
    const actionBarHeight = this.isSomethingSelected ? ACTION_BAR_HEIGHT : 0;
    return this.$rootScope.navbarHeight + this.employeeHeaderHeight + actionBarHeight;
  }

  get users() {
    return this.items;
  }

  // groups only store users ids
  set users(value) {
    this.items = value
      .map((member) => this.PersonaCollection.personasDict[member.id])
      .filter((member) => member.active);
  }

  getManageTableRowSize(user) {
    const isExpanded = {
      positions: user.$$positionsExpanded,
      locations: user.$$locationsExpanded,
    };

    return this.UserUtils.getManageTableRowSize(user, isExpanded);
  }

  removeMember(user) {
    if (!this.canRemoveMember(user.id)) {
      return;
    }

    const index = this.users.findIndex((u) => u.id === user.id);
    this.users.splice(index, 1);
    this.form.$setDirty();
  }

  removeSelectedMembers() {
    const selectedMembersKeys = Object.keys(this.selectedItemIds);
    const ids = selectedMembersKeys.filter(
      (userId) =>
        this.selectedItemIds[userId] &&
        userId in this.visibleItemsDict &&
        this.canRemoveMember(userId)
    );

    if (ids.length) {
      const members = this.users.filter((u) => !ids.includes(u.id.toString()));
      this.setUsers(members);
    }
  }

  canRemoveMember(id) {
    return !this.nonDeletable || !(id in this.nonDeletable);
  }

  async addEmployees() {
    const ctrl = this;
    const result = await this.$uibModal
      .open({
        name: 'AddEmployeeModal',
        templateUrl: addEmployeeModalUrl,
        backdrop: 'static',
        controller(PersonaCollection, $uibModalInstance, selected, nonDeletable) {
          'ngInject';

          this.users = PersonaCollection.users.filter((user) => !selected.includes(user));
          this.nonDeletableMembers = nonDeletable;
          this.members = [];
          this.submit = () => {
            ctrl.createAnyUsers = this.createAnyUsers;
            $uibModalInstance.close(this.members);
          };

          this.clearMembers = () => {
            this.members = [];
          };

          this.addAllUsers = () => {
            this.members = [...this.users];
          };
        },
        resolve: {
          selected() {
            return ctrl.users;
          },
          nonDeletable() {
            return ctrl.nonDeletable || [];
          },
        },
        controllerAs: 'ctrl',
        size: '620',
      })
      .result.ignoreCancel();

    if (result) {
      this.addUsers(result);
    }
  }

  setUsers(users) {
    this.users = users;
    this.form.$setDirty();
  }

  addUsers(users) {
    this.users.push(...users);
    this.form.$setDirty();
  }

  deleteUser(user) {
    const successCallback = (result) => {
      if (!result) {
        return;
      }

      this.users = this.users.filter((u) => u.id !== user.id);
      this.PersonaCollection.users = this.PersonaCollection.users.filter((u) => u.id !== user.id);
    };

    this.UserUtils.deleteOrDeactivateUser(user, 'delete', successCallback);
  }

  deactivateUser(user) {
    const successCallback = (result) => {
      if (!result) {
        return;
      }

      user.active = false;
    };

    this.UserUtils.deleteOrDeactivateUser(user, 'deactivate', successCallback);
  }

  async activateUser(user) {
    user.active = true;
    try {
      await user.put({ 'user-fields': 'full' });
    } catch (e) {
      user.active = false;
    }
  }
}

export default {
  controller: GroupEmployeeTabCtrl,
  templateUrl,
  controllerAs: 'ctrl',
  bindings: {
    users: '=',
    createAnyUsers: '=',
    form: '<',
    nonDeletable: '<',
    type: '@',
    isTabActive: '<',
  },
};
